import { useEffect, useState } from 'react';
import { CATEGORIES_EVENTS, META_EVENTS } from '../constants/CONTROLLERS_EVENT_TYPES';
import type { IStateController } from '../lib/widget/state/state.interface';
import { useInjection } from 'inversify-react';
import { STATE_MODULE_IDS } from '../lib/widget/state/state.types';
import type { ITicketsController } from '../lib/widget/tickets/tickets.interface';
import { TICKETS_MODULE_IDS } from '../lib/widget/tickets/tickets.types';

const useTableSelector = () => {
  const stateController: IStateController = useInjection(STATE_MODULE_IDS.STATE_CONTROLLER);
  const ticketsController: ITicketsController = useInjection(TICKETS_MODULE_IDS.TICKETS_CONTROLLER);

  const { Widget } = window;
  const [selectedSector, selectSector] = useState(null);
  const [sectors, setSectors] = useState(ticketsController.sectors);
  const [categories, setCategories] = useState(Widget.categoriesController.categories);
  const { dates } = Widget.metaController.meta;

  const setTicketsData = () => {
    setSectors(ticketsController.sectors);
    setCategories(Widget.categoriesController.categories);
  };

  useEffect(() => {
    ticketsController.addListener(ticketsController.events.RENDER_TICKETS, setTicketsData);
    Widget.categoriesController.addListener(CATEGORIES_EVENTS.SET_PRICES, setTicketsData);
    stateController.addListener(stateController.events.TICKETS_DATA_LOADED, setTicketsData);
    Widget.metaController.addListener(META_EVENTS.CHANGE_SECTOR, resetSector);
    return () => {
      ticketsController.removeListener(ticketsController.events.RENDER_TICKETS, setTicketsData);
      Widget.categoriesController.removeListener(CATEGORIES_EVENTS.SET_PRICES, setTicketsData);
      stateController.removeListener(stateController.events.TICKETS_DATA_LOADED, setTicketsData);
      Widget.metaController.removeListener(META_EVENTS.CHANGE_SECTOR, resetSector);
    };
  }, []);

  const resetSector = (sector) => {
    if (!sector) {
      selectSector(null);
    }
  };

  return { selectedSector, sectors, categories, dates, selectSector };
};

export default useTableSelector;
